//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/RoutingCommon.js";
import "../no/Builder.js";
import "../RoutingCommon/RoutingCommon.PathDimensionBuilder.js";
import "../no/Expression.js";
import "../Assemblies/Assemblies.SelectComponent.js";
import "../Routing/Routing.RouteObjectCollector.js";
import "../Routing/Routing.StockBlockBuilder.js";
import "../no/Expression.js";
import "../no/Routing.js";
import "../no/SelectObject.js";
let d=[[[0,"AddInsulationOnFittings",1,0],[0,"ApplicationMethod",1,0],[1,"EndOffsetPoint",0,"RoutingCommon.PathDimensionBuilder",0],[1,"EndPoint",0,"RoutingCommon.PathDimensionBuilder",0],[1,"GapDistance",0,"Expression",0],[1,"InsulationPartOccurrenceSelection",0,"Assemblies.SelectComponent",0],[0,"OffsetMethod",1,0],[1,"OverlapPercentage",0,"Expression",0],[1,"SegmentCollector",0,"Routing.RouteObjectCollector",0],[1,"StartOffsetPoint",0,"RoutingCommon.PathDimensionBuilder",0],[1,"StartPoint",0,"RoutingCommon.PathDimensionBuilder",0],[1,"StockSettings",0,"Routing.StockBlockBuilder",0],[0,"SwitchStartEnd",1,0],[0,"WrapMethod",1,0]],[[[],"PreCommit",{},0,0],[[],"GetLogicalObject",{R_:{logicalObject:"PDM.LogicalObject"}},0,0],[[],"SuggestWrapMethodBasedOnStockSettings",{R_:{wrapMethod:''}},0,0],[[],"UpdatePath",{},0,0],[["orderedPathCount","orderedPath"],"GetOrderedPath",{},0,0],[["partToCreatePointIn","pointLocation"],"CreateScalarPoint",{R_:{point:"TaggedObject"}},2,0]],[]];
SPLM.RoutingCommon.InsulationBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.RoutingCommon.InsulationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.RoutingCommon.InsulationBuilder.WrapType = Object.freeze({
    "NoWarp" : "NoWarp", "OverlapSpiral" : "OverlapSpiral", "StripedSpiral" : "StripedSpiral"});

SPLM.RoutingCommon.InsulationBuilder.ApplicationType = Object.freeze({
    "EntireSegments" : "EntireSegments", "Offsets" : "Offsets", "PointAndLength" : "PointAndLength"});

SPLM.RoutingCommon.InsulationBuilder.OffsetMethodType = Object.freeze({
    "FromBothEnds" : "FromBothEnds", "FromOneEnd" : "FromOneEnd"});

export default SPLM;